//   const [openTerms, termsDialog] = useConsentTermsDialog();
//   … <TermsLink onOpen={openTerms}>{label}</TermsLink> … {termsDialog}
// Petition pages use TermsModal directly since the statement arrives on the record.

import { useCallback, useEffect, useState } from 'react';
import { fetchConsentTerms } from '../api';
import TermsModal from './TermsModal';
import { ENGLISH_TERMS } from './englishTerms';

const scenarioSlug = () => new URLSearchParams(window.location.search).get('terms') || undefined;

// Opening waits until the fetch answers (terms !== undefined). Dropping that check would
// show the "could not load" message first and then swap in the real terms.
export function useConsentTermsDialog() {
  const [terms, setTerms] = useState(undefined); // undefined = not answered yet
  const [wanted, setWanted] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetchConsentTerms(scenarioSlug()).then((t) => {
      if (!cancelled) setTerms(t);
    });
    return () => { cancelled = true; };
  }, []);

  const open = useCallback(() => setWanted(true), []);
  const close = useCallback(() => setWanted(false), []);

  const dialog = (
    <TermsModal open={wanted && terms !== undefined} onClose={close} terms={terms ?? null} />
  );
  return [open, dialog];
}

// The English page's version: fixed English text, so nothing is fetched.
export function useEnglishTermsDialog() {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  return [open, <TermsModal open={isOpen} onClose={close} english={ENGLISH_TERMS} />];
}

// Removing type="button" would make the link submit the donor form it sits in.
export function TermsLink({ onOpen, children }) {
  return (
    <button type="button" className="consent-terms" onClick={onOpen}>
      {children}
    </button>
  );
}
